function sortMessages(messages) {
  return messages.sort(
    (msg1, msg2) =>
      Date.parse(msg1["created_at"]) - Date.parse(msg2["created_at"])
  );
}

// Build list of objects grouped by question linking user, assistant and assistant_rd
// If assistant_rd is missing for a question, it will be null in the output
export function groupMessagesByQuestion(messages) {
  if (!Array.isArray(messages)) return [];

  const sorted = sortMessages([...messages]);

  const userById = new Map();
  const assistantByQuestionId = new Map();
  const assistantRdByQuestionId = new Map();

  sorted.forEach((msg) => {
    const role = msg["role"];
    if (role === "user" && msg["message_id"]) {
      userById.set(msg["message_id"], msg);
    } else if (role === "assistant" && msg["question_id"]) {
      assistantByQuestionId.set(msg["question_id"], msg);
    } else if (role === "assistant_rd" && msg["question_id"]) {
      assistantRdByQuestionId.set(msg["question_id"], msg);
    }
  });

  const triples = [];
  userById.forEach((userMsg, messageId) => {
    const assistant = assistantByQuestionId.get(messageId) || null;
    const assistant_rd = assistantRdByQuestionId.get(messageId) || null;
    triples.push({ query: userMsg, answer: assistant, answer_rd: assistant_rd });
  });

  return triples;
}
